import { render } from "./ErrorPage.vue?vue&type=template&id=7cd3a008&scoped=true"
import script from "./ErrorPage.vue?vue&type=script&lang=js"
export * from "./ErrorPage.vue?vue&type=script&lang=js"

import "./ErrorPage.vue?vue&type=style&index=0&id=7cd3a008&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd3a008"]])

export default __exports__